var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "a/icons/16/lock-round") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a/icons/16/lock-round",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M7.99920006,2 C6.45280279,2 5.19920011,3.30090846 5.19920011,4.90566038 L5.19920011,5.75079245 C5.19938844,5.8538822 5.12635507,5.94135869 5.02800011,5.95584906 C4.43771013,6.04456607 3.99980597,6.56972315 4.00000006,7.18867925 L4.00000006,11.754717 C4.00000006,12.4424678 4.53725842,13 5.20000011,13 L10.8,13 C11.4627417,13 12.0000001,12.4424678 12.0000001,11.754717 L12.0000001,7.18867925 C12.0000001,6.56917706 11.5613255,6.04381836 10.9704,5.95584906 C10.8720451,5.94135869 10.7990117,5.8538822 10.7992,5.75079245 L10.7992,4.90566038 C10.7992,3.30090846 9.54559734,2 7.99920006,2 Z M8.00000006,9.05660377 C8.44182786,9.05660377 8.80000005,9.42829191 8.80000005,9.88679245 C8.80000005,10.345293 8.44182786,10.7169811 8.00000006,10.7169811 C7.55817227,10.7169811 7.20000008,10.345293 7.20000008,9.88679245 C7.20000008,9.42829191 7.55817227,9.05660377 8.00000006,9.05660377 Z M8.00000006,3.66037736 C8.66274175,3.66037736 9.20000005,4.21790956 9.20000005,4.90566038 L9.20000005,5.73584906 C9.20000005,5.85047419 9.110457,5.94339623 9.00000005,5.94339623 L7.00000008,5.94339623 C6.88954313,5.94339623 6.80000008,5.85047419 6.80000008,5.73584906 L6.80000008,4.90566038 C6.80000008,4.21790956 7.33725838,3.66037736 8.00000006,3.66037736 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockRound);
export default __webpack_public_path__ + "static/media/lock-round.4ab270ee.svg";
export { ForwardRef as ReactComponent };